import { createSafeContext } from '@/util';

import type { VBaseInputContextValue } from './type';

const BaseInputContext = createSafeContext<VBaseInputContextValue>();

export default BaseInputContext;
